import React, { Fragment, useMemo } from "react";
import styled, { createGlobalStyle } from "styled-components";
import { Redirect, useLocation } from "@reach/router";
import { View, Text, Link } from "./components";
import { graphql, Query } from "react-apollo";
import { compose } from "recompose";
import tagAlbumsQuery from "./graphql/tagAlbumsQuery";
import albumQuery from "./graphql/albumQuery";
import friendlyUrl from "slug";
import Gallery from "./components/Gallery";
import historyLength from "./utilities/historyLength";
import professions from "./professions";
import CloseIcon from "./components/CloseIcon";
import categoriesProjects from "./categoriesProjects";
import { useMedia } from "use-media";
import { get, getProfessions } from "./helpers";
import { CategoriesMenu } from "./Artist";
import { Helmet } from "react-helmet";
import qs from "qs";

const AlternateBackgroundColor = createGlobalStyle`
  :root {
    --bg-color: #FAFAFA;
  }
`;

const Container = styled(View)``;
//   min-height: 120vmin;

/*
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  */
const Navigation = styled(View)`
  z-index: 999;
`;

const InfoPrevNext = styled(View).attrs(() => ({
  px: [3, 3, 4],
  pb: [0, 2, 3],
}))`
  display: flex;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  ${({ theme: { maxWidth } }) => maxWidth};
`;

const PrevNext = styled(Text)`
  @media (min-width: 520px) {
    min-width: 148px;
  }
  ${({ right }) => right && `text-align: right;`}
`;

const PrevNextLink = styled(Link)`
  @media (min-width: 520px) {
    min-width: 148px;
  }
  ${({ right }) => right && `text-align: right;`}
`;

const MaxWidth = styled(View)`
  position: relative;
  ${({ theme: { maxWidth } }) => maxWidth};
  display: flex;
`;

const TitleLink = styled(Link)`
  display: block;
  max-width: calc(50vw - 4rem);
  overflow: hidden;
  text-overflow: ellipsis;
  @media (max-width: 520px) {
    max-width: calc(100vw - 5rem);
    white-space: normal;
  }
`;

const GalleryPage = ({ artist, album, data, category }) => {
  const isWide = useMedia({ minWidth: 520 });

  const albumData =
    data.allAlbums && data.allAlbums.length > 0 && data.allAlbums[0];
  const artistTag = data.User
    ? data.User.tags.find((tag) => friendlyUrl(tag.name) === artist)
    : null;
  const artistTagName = artistTag ? artistTag.name : null;
  const albumTitle = albumData
    ? albumData.title.indexOf(" - ") > -1
      ? albumData.title.split(" - ")[1]
      : albumData.title
    : null;

  const customTitle =
    albumData &&
    get(
      albumData.keyValues.find((keyValue) => keyValue.key.name === "title"),
      "value"
    );

  const tags = "User" in data && data.User.tags;
  const tag = tags && tags.find((tag) => professions.includes(tag.name));
  const albumProfessions = albumData ? getProfessions(albumData.tags) : [];

  const location = useLocation();
  const queryParams = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  let meta = albumData
    ? albumData.keyValues
        .filter(
          (keyValue) => !["title", "instagram"].includes(keyValue.key.name)
        )
        .map((keyValue) => {
          return {
            key: keyValue.key.name,
            value: keyValue.value,
          };
        })
    : [];

  /*
  meta = [
    ...meta,
    ...albumProfessions.map(albumProfession => ({
      key: albumProfession,
      value: artistTagName
    }))
  ]
*/
  const whereWasI = useMemo(() => sessionStorage.getItem("whereWasI"), []);
  console.log({ whereWasI });

  const education = artist === "makeup-school";

  if (!data.loading && !albumTitle) {
    return <Redirect noThrow to="/" />;
  }

  return (
    <Container>
      <Helmet>
        <title>
          {artistTagName || ""} • {customTitle || albumTitle || ""} • House Of
          Orange Agency • Amsterdam
        </title>
        <meta
          name="og:title"
          content={`${artistTagName} • ${
            customTitle || albumTitle || ""
          } • House Of Orange Agency • Amsterdam`}
        />
      </Helmet>
      <AlternateBackgroundColor />
      <Link
        to={
          education
            ? `/education`
            : `/artist/${friendlyUrl(artistTagName || "any")}${
                !!queryParams.profession
                  ? `?profession=${queryParams.profession}`
                  : ""
              }`
        }
        onClick={(e) => {
          if (historyLength() > 0) {
            e.preventDefault();
            window.history.back();
          }
        }}
        onMouseEnter={(e) => {
          console.log(parseInt(window.history.length, 10), historyLength());
        }}
        style={{
          position: "fixed",
          top: 32,
          zIndex: 1997,
          ...(isWide ? { left: "50%" } : { right: 16 }),
        }}
      >
        <CloseIcon style={{ marginLeft: -15 }} pt={[0, 2, 3]} />
      </Link>

      <Navigation px={[3, 3, 4]} pb={[0, 2, 3]}>
        <MaxWidth>
          {artistTagName && (
            <Query
              query={tagAlbumsQuery}
              fetchPolicy="cache-and-network"
              variables={{
                user: process.env.REACT_APP_WHITESPACE_USER,
                tagName: artistTagName,
              }}
            >
              {({ loading, error, data }) => {
                //
                //

                const albums = data?.allTags?.[0]?.albums;
                const categoryAlbums =
                  albums &&
                  categoriesProjects
                    .map((category) => ({
                      category,
                      albums: albums.filter((album) => {
                        return album.tags.find((tag) => tag.name === category);
                      }),
                    }))
                    .reduce(
                      (collect, category) => [
                        ...collect,
                        ...category.albums
                          .sort((a, b) => b.order - a.order)
                          .map((album) => ({
                            ...album,
                            to: `../../${friendlyUrl(
                              category.category || "nothing"
                            )}/${friendlyUrl(
                              album.title.split(" - ")[1] || "nothing"
                            )}`,
                          })),
                      ],
                      []
                    );

                const albumIndex = categoryAlbums?.findIndex(
                  (album) => album.id === albumData.id
                );
                console.log({ albumIndex });
                // bovenstaande nog in de juiste category volgorde zetten!!
                // extract artist professions
                const bioAlbum = albums?.find((album) =>
                  album.slug.includes("-bio")
                );
                let professions = bioAlbum ? getProfessions(bioAlbum.tags) : [];
                if (!!queryParams.profession) {
                  professions = professions.filter(
                    (entry) =>
                      friendlyUrl(entry.replace("&", "")) ===
                      queryParams.profession
                  );
                }
                //
                //
                const Header = ({ professions, education }) => (
                  <View
                    style={{
                      position: "fixed",
                      left: 0,
                      right: 0,
                      top: 0,
                      display: "flex",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      zIndex: 998,
                    }}
                    px={[4, 4, 5]}
                    pt={[0, 2, 3]}
                  >
                    <View style={{ width: "100%" }}>
                      <MaxWidth>
                        <View mt={[5, 5, 5]} style={{ flex: 1 }}>
                          <TitleLink
                            to={
                              education
                                ? `/education`
                                : `/artist/${friendlyUrl(artistTagName)}${
                                    queryParams.profession
                                      ? `?profession=${queryParams.profession}`
                                      : ""
                                  }`
                            }
                            onClick={(e) => {
                              if (whereWasI !== "home" && historyLength() > 0) {
                                e.preventDefault();
                                window.history.back();
                              }
                            }}
                            textStyle={"headline"}
                            style={{ color: "black" }}
                          >
                            {artistTagName}
                          </TitleLink>
                          {isWide && !education && (
                            <CategoriesMenu
                              {...{
                                artistTagName,
                                albumCategory: category,
                                props: { isWide },
                                albumData: bioAlbum,
                                queryParams,
                              }}
                            />
                          )}
                        </View>
                        {isWide && (
                          <Text mt={[5, 5, 5]}>
                            {professions.map((profession) => (
                              <span style={{ marginLeft: 16 }} key={profession}>
                                {profession}
                              </span>
                            ))}
                          </Text>
                        )}
                      </MaxWidth>
                    </View>
                  </View>
                );

                if (loading && !data?.allTags)
                  return (
                    <Fragment>
                      <Header professions={[]} education={education} />

                      <InfoPrevNext>
                        <PrevNext style={{ opacity: 0.2 }}>
                          {isWide ? `Previous Project` : null}
                        </PrevNext>
                        <Text style={{ flex: 1 }} center mb={2}>
                          {customTitle || albumTitle}
                          <View style={{ minHeight: "2em" }}>
                            {meta
                              .filter((item) => item.key !== "with")
                              .map((item, index) => (
                                <Text
                                  inline
                                  mx={2}
                                  key={index}
                                  textStyle="caption"
                                >
                                  {item.key} - {item.value}
                                </Text>
                              ))}
                          </View>
                        </Text>
                        <PrevNext style={{ opacity: 0.2 }} right>
                          {isWide ? `Next Project` : null}
                        </PrevNext>
                      </InfoPrevNext>
                    </Fragment>
                  );
                if (error && !data.allTags)
                  return <Text>{`Error! ${error.message}`}</Text>;

                return (
                  <Fragment>
                    <Header
                      professions={education ? [] : professions}
                      education={education}
                    />

                    <InfoPrevNext>
                      {albumIndex > 0 ? (
                        <PrevNextLink
                          to={categoryAlbums[albumIndex - 1].to}
                          replace
                        >
                          {isWide ? `Previous Project` : null}
                        </PrevNextLink>
                      ) : (
                        <PrevNext style={{ opacity: 0.2 }}>
                          {isWide ? `Previous Project` : null}
                        </PrevNext>
                      )}
                      <Text style={{ flex: 1 }} center mb={2}>
                        {customTitle || albumTitle}
                        <View style={{ minHeight: "2em" }}>
                          {meta
                            .filter((item) => item.key !== "with")
                            .map((item, index) => (
                              <Text
                                inline
                                mx={2}
                                key={index}
                                textStyle="caption"
                              >
                                {item.key} - {item.value}
                              </Text>
                            ))}
                        </View>
                      </Text>
                      {albumIndex < categoryAlbums.length - 1 ? (
                        <PrevNextLink
                          to={categoryAlbums[albumIndex + 1].to}
                          replace
                          right
                        >
                          {isWide ? `Next Project` : null}
                        </PrevNextLink>
                      ) : (
                        <PrevNext style={{ opacity: 0.2 }} right>
                          {" "}
                          {isWide ? `Next Project` : null}
                        </PrevNext>
                      )}
                    </InfoPrevNext>
                  </Fragment>
                );
              }}
            </Query>
          )}
        </MaxWidth>
      </Navigation>
      {!data.loading && albumData && (
        <Gallery slides={albumData.slides} isWide={isWide} />
      )}
    </Container>
  );
};

export default compose(
  /*
  graphql(tagAlbumsQuery, {
    options: () => {
      return {
        fetchPolicy: 'cache-and-network',
        variables: {
          user: process.env.REACT_APP_WHITESPACE_USER,
          tagName: 'Bio'
        }
      }
    }
  }),
  */
  graphql(albumQuery, {
    options: ({ artist, album }) => {
      console.log("artist to query", artist);
      return {
        fetchPolicy: "cache-and-network",
        variables: {
          user: process.env.REACT_APP_WHITESPACE_USER,
          slug: artist
            ? `${artist === "makeup-school" ? "education" : artist}-${album}`
            : album,
        },
      };
    },
  })
)(GalleryPage);
